import { AuthenticatedApi } from '../utils/Api';
import { capturePostHogEvent } from '../utils/posthog';

export const AnalyticsService = {
  async trackAnalytics(eventName, distinct_id, body) {
    // Mirrored into PostHog so the same product events sit alongside the session
    // replays. Fire-and-forget, and it swallows its own errors: analytics must
    // not be able to fail the flow that reported the event.
    capturePostHogEvent(eventName, { distinct_id, ...body });

    await AuthenticatedApi.post('/api/1.0/analytics-service/track', {
      eventName,
      distinct_id,
      data: body,
    });
  },
  async setUserProfile(distinct_id, email, host, data) {
    await AuthenticatedApi.post('/api/1.0/analytics-service/set-user-profile', {
      distinct_id,
      email,
      host,
      data,
    });
  },
};
